import { createI18n } from 'vue-i18n'
import * as vi from '~/lang/vi'

const locale = 'vi'
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  messages: { vi }
})
export const replace = (message: string, params: {} | []) => {
  return message.replace(/(\d:)?\[([^\]]+)\]/g, function (_, param, placeholder) {
    if (!param || !params) {
      return placeholder in params
        ? params[placeholder as keyof typeof params]
        : params && placeholder in params
        ? params[placeholder as keyof typeof params]
        : `{${placeholder}}`
    }
    if (!Array.isArray(params)) {
      return placeholder in params ? params[placeholder as keyof typeof params] : `[${placeholder}]`
    }
    const paramIndex = Number(param.replace(':', ''))
    return paramIndex in params ? params[paramIndex] : `${param}(${placeholder})`
  })
}
